"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _assetMapper = require("../../../../lib/assetMapper");

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var FloatingLabelInput =
/*#__PURE__*/
function (_Backbone$View) {
  _inherits(FloatingLabelInput, _Backbone$View);

  _createClass(FloatingLabelInput, [{
    key: "template",
    value: function template(_ref) {
      var className = _ref.className,
          id = _ref.id,
          label = _ref.label,
          type = _ref.type;
      return "\n            <div class=\"floatingLabelInput ".concat(className, "\">\n                <input id=\"").concat(id, "\" name=\"").concat(id, "\" type=\"").concat(type, "\" aria-label=\"").concat(label, "\" ").concat(this.autocompleteHint ? "autocomplete=\"".concat(this.autocompleteHint, "\"") : '', ">\n                <label class=\"inputLabel\" labelFor=\"").concat(id, "\" title=\"").concat(label, "\">").concat(label, "</label>\n                ").concat(type === 'password' ? "\n                    <img class=\"showPasswordIcon\" alt='".concat(window.text('signInPage.libraryCard.showPassword'), "' src='").concat((0, _assetMapper.toStaticUrl)('img/icon-password-show.png'), "'/>\n                    <img class=\"showPasswordIcon\" style=\"display: none\" alt='").concat(window.text('signInPage.libraryCard.hidePassword'), "' src='").concat((0, _assetMapper.toStaticUrl)('img/icon-password-hide.png'), "'/>\n                ") : '', "\n                <p class=\"invalidLabel\">").concat(window.text('signInPage.invalidField', {
        fieldName: label
      }), "</p>\n            </div>");
    }
  }]);

  function FloatingLabelInput(_ref2) {
    var _this;

    var className = _ref2.className,
        id = _ref2.id,
        label = _ref2.label,
        type = _ref2.type,
        autocompleteHint = _ref2.autocompleteHint;

    _classCallCheck(this, FloatingLabelInput);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FloatingLabelInput).apply(this, arguments));
    _this.type = type || 'text';
    _this.floated = false;
    _this.floatPollIntervalMS = 100;

    _.extend(_assertThisInitialized(_this), arguments[0]);

    return _this;
  }

  _createClass(FloatingLabelInput, [{
    key: "render",
    value: function render() {
      this.eventsAttached = false;
      this.$el.empty().append(this.template(this));
      this.$input = this.$el.find('input');

      this._attachEvents();

      return this;
    }
  }, {
    key: "_attachEvents",
    value: function _attachEvents() {
      var _this2 = this;

      if (!this.eventsAttached) {
        this.$input.on('focus input change', function () {
          _this2.floatLabel();
        });
        this.$input.on('blur', function () {
          if (!_this2.$input.val()) {
            _this2.sinkLabel();
          }
        });

        if (window.featureManager.isEnabled('pollForAutofill')) {
          if (!window.featureManager.isEnabled('idcDuplicateHandlerFix')) {
            console.log('start polling');
          }

          setTimeout(function () {
            return _this2.checkForWebkitAutofill();
          }, this.floatPollIntervalMS);
        }

        if (this.type === 'password') {
          this.$input.css('padding-right', '3rem');
          this.$el.find('.showPasswordIcon').click(function () {
            _this2.$el.find('.showPasswordIcon').toggle();

            _this2.$input.focus();

            if (_this2.$input.attr('type') === 'password') {
              _this2.$input.attr('type', 'text');
            } else {
              _this2.$input.attr('type', 'password');
            }
          });
        }

        this.eventsAttached = true;
      }
    } // poll for autofill by webkit.  Webkit browsers
    // do not trigger any event on autofill until the user
    // interacts with the page in some way.  The autofilled
    // value is also not available on the element until that time.
    // However, the browser-specific pseudo class is applied.

  }, {
    key: "checkForWebkitAutofill",
    value: function checkForWebkitAutofill() {
      var _this3 = this;

      if (this.$input.is(':-webkit-autofill') && !this.floated) {
        this.floatLabel();
      } // Since we are solely concerned with autofill and other cases are covered by explicit events,
      // we can stop polling as soon as the label is floated


      if (!this.floated) {
        setTimeout(function () {
          return _this3.checkForWebkitAutofill();
        }, this.floatPollIntervalMS);
      }
    }
  }, {
    key: "floatLabel",
    value: function floatLabel() {
      if (window.featureManager.isEnabled('pollForAutofill') && this.floated) {
        return;
      }

      this.$el.find('.inputLabel').addClass('secondary-color');
      this.$el.find('.floatingLabelInput').addClass('focused');
      this.floated = true;
    }
  }, {
    key: "sinkLabel",
    value: function sinkLabel() {
      if (window.featureManager.isEnabled('pollForAutofill') && !this.floated) {
        return;
      }

      this.$el.find('.inputLabel').removeClass('secondary-color');
      this.$el.find('.floatingLabelInput').removeClass('focused');
      this.floated = false;
    }
  }, {
    key: "validateNonEmpty",
    value: function validateNonEmpty() {
      if (this.$input.val()) {
        return true;
      }

      this.displayInvalid();
      return false;
    }
  }, {
    key: "displayInvalid",
    value: function displayInvalid() {
      var _this4 = this;

      if (!this.invalid) {
        this.$el.find('.floatingLabelInput').addClass('invalid');
        this.$input.on('focus', function () {
          _this4.clearInvalid();
        });
        this.invalid = true;
      }
    }
  }, {
    key: "clearInvalid",
    value: function clearInvalid() {
      if (this.invalid) {
        this.$el.find('.floatingLabelInput').removeClass('invalid');
        this.invalid = false;
      }
    }
  }]);

  return FloatingLabelInput;
}(Backbone.View);

exports["default"] = FloatingLabelInput;